import { render, staticRenderFns } from "./StandardTestOutcome.vue?vue&type=template&id=65244962&"
import script from "./StandardTestOutcome.vue?vue&type=script&lang=js&"
export * from "./StandardTestOutcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports